const Head = () => {
  return (
    <div className="title-field">
      <div>
        <h1 className="title">Minesweeper</h1>
        <h2 className="subtitle">by JHE-WEI, JHANG</h2>
      </div>
    </div>
  );
}

export default Head;
